// src/components/Departments/Table/DepartmentsTableRow.jsx
import React from "react";
import { TableRow, TableCell, Checkbox, IconButton, Chip } from "@mui/material";
import { MoreVert as MoreVertIcon } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";

const DepartmentsTableRow = ({
    department,
    index,
    selectedIds,
    onRowCheckboxClick,
    onMenuOpen,
    isDark,
    menuDisabled,
}) => {
    const { i18n } = useTranslation();
    const currentLng = i18n.language || "en";
    const lng = currentLng.startsWith("ar") ? "ar" : "en";
    const isArabic = lng === "ar";

    const isSelected = selectedIds.indexOf(department.id) !== -1;

    return (
        <TableRow
            hover
            role="checkbox"
            aria-checked={isSelected}
            tabIndex={-1}
            key={department.id}
            selected={isSelected}
        >
            <TableCell padding="checkbox">
                <Checkbox
                    checked={isSelected}
                    onChange={(event) => onRowCheckboxClick(event, department.id)}
                />
            </TableCell>

            <TableCell align="center" sx={{ fontWeight: 600 }}>{index + 1}</TableCell>

            <TableCell align={isArabic ? "right" : "left"}>
                {department.name?.[lng] || department.name?.[lng === 'ar' ? 'en' : 'ar'] || "---"}
            </TableCell>

            <TableCell align="center">
                <Chip label={department.slug} size="small" variant="outlined" color="primary" sx={{ borderRadius: 1.5 }} />
            </TableCell>

            {/* <TableCell align="center">
                {department.sort_order}
            </TableCell> */}

            <TableCell align="center">
                <Chip
                    label={department.is_active
                        ? (isArabic ? "نشط" : "Active")
                        : (isArabic ? "غير نشط" : "Inactive")
                    }
                    color={department.is_active ? "success" : "default"}
                    size="small"
                />
            </TableCell>

            <TableCell align="center">
                {dayjs(department.created_at).format("YYYY-MM-DD")}
            </TableCell>

            <TableCell align="center">
                <IconButton
                    size="large"
                    color="inherit"
                    onClick={(e) => onMenuOpen(e, department)}
                    disabled={menuDisabled}
                >
                    <MoreVertIcon />
                </IconButton>
            </TableCell>
        </TableRow>
    );
};

export default DepartmentsTableRow;
